// extracted by mini-css-extract-plugin
export default {"showHideBtn":"ShowTrainersShifts_showHideBtn__IeMLv","shiftsHeader":"ShowTrainersShifts_shiftsHeader__a3Uw8","shifts":"ShowTrainersShifts_shifts__4LHnf"};